import React from "react";

const Navbar = () => {
  return (
    <div className="bg-gray-800 ">
      <div className="h-16 px-8 flex items-center">
        <p className="text-white font-bold">Accommodation Companion</p>


        
      </div>
    </div>
  );
};

export default Navbar;
